import { AuthResult } from '@/utils/auth'
import { UserRole } from '@/utils/types'
import { createStore } from 'zustand/vanilla'

export type AuthState = {
  displayName: string;
  roles: UserRole[];
  organisationId: string;
}

export type AuthActions = {
  //setAuth: (auth: AuthResult) => void
}

export type AuthStore = AuthState & AuthActions

export const initAuthStore = (auth: AuthResult): AuthState => {
  return {
    displayName: auth?.user?.user_metadata?.displayName || "",
    roles: auth?.token?.user_roles as UserRole[] || [],
    organisationId: auth?.user?.user_metadata?.organisationId || ""
  }
}

export const defaultInitState: AuthState = {
  displayName: "",
  roles: [],
  organisationId: ""
}

export const createAuthStore = (
  initState: AuthState = defaultInitState,
) => {
  return createStore<AuthStore>()((set) => ({
    ...initState
  }))
}

